module.exports = __webpack_public_path__ + "static/media/symbol_sdf.vertex.a1b41ff6.glsl";